import { isObjectRecord } from "./BoardRecord";

/**
 * The name a stage declares, when it declares one that is not blank; a blank
 * name is no name. `stage` is a stored or proposed entry that may not parse,
 * so its shape is checked, not assumed.
 */
export function declaredStageName(stage: unknown): string | undefined {
  return isObjectRecord(stage) &&
    typeof stage.name === "string" &&
    stage.name.trim() !== ""
    ? stage.name
    : undefined;
}
